import { useNavigate } from 'react-router-dom';
import { categories, getFilterAttribute } from '../../data/categories';

// Megamenu Component
export const Megamenu = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/categories/${category.slug}`);
    setIsOpen(false);
  };

  const handleSubcategoryClick = (category, subcategory) => {
    // For grape varieties and regions, use the structured URL format
    const type = subcategory.type === 'region' ? 'regions' : 
                 subcategory.type === 'grape' ? 'cepages' : 
                 subcategory.type === 'country' ? 'pays' : 'cepages';
    const slug = subcategory.label.toLowerCase().replace(/\s+/g, '-');
    navigate(`/categories/${type}/${slug}`);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="megamenu-overlay" onClick={() => setIsOpen(false)}>
      <div className="megamenu" onClick={(e) => e.stopPropagation()}>
        <div className="megamenu-content">
          <div className="megamenu-header">
            <h3>Catégories de vins</h3>
            <button className="megamenu-close" onClick={() => setIsOpen(false)}>Fermer</button>
          </div>
          
          <div className="megamenu-grid">
            {categories.map((category) => {
              const IconComponent = category.icon;
              return (
                <div key={category.id} className="megamenu-category">
                  <div 
                    className="category-header"
                    onClick={() => handleCategoryClick(category)}
                  >
                    <IconComponent size={24} />
                    <h4>{category.name}</h4>
                  </div>
                  
                  <ul className="subcategory-list">
                    {category.subcategories.map((subcategory, index) => (
                      <li key={index}>
                        <button 
                          onClick={() => handleSubcategoryClick(category, subcategory)}
                          className="subcategory-link"
                        >
                          {subcategory.type === 'region' && 'Région : '}
                          {subcategory.type === 'grape' && 'Cépage : '}
                          {subcategory.type === 'country' && 'Pays : '}
                          {subcategory.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}; 